module.exports = __webpack_public_path__ + "img/hu.456f4b1b.svg";